import { Chip } from '@mui/material';
import { CatalogueItemGovernanceStatus } from '../../../mocks/data/catalogueGovernanceData';

const GOVERNANCE_STATUS_COLOR: Record<CatalogueItemGovernanceStatus, 'success' | 'error' | 'warning'> = {
  [CatalogueItemGovernanceStatus.Approved]: 'success',
  [CatalogueItemGovernanceStatus.Blocked]: 'error',
  [CatalogueItemGovernanceStatus.PendingPriceApproval]: 'warning',
  [CatalogueItemGovernanceStatus.OffContract]: 'warning',
};

interface GovernanceStatusChipProps {
  status: CatalogueItemGovernanceStatus;
}

/** Shared chip for catalogue governance status (approved/blocked/off-contract/pending price
 * approval) - used on the Procurement Products list row and the Catalogue Governance queue
 * screen so both stay visually consistent. Demo Mode only, see
 * src/mocks/data/catalogueGovernanceData.ts. */
const GovernanceStatusChip: React.FC<GovernanceStatusChipProps> = ({ status }) => (
  <Chip label={status}
    size="small"
    color={GOVERNANCE_STATUS_COLOR[status]} />
);

export default GovernanceStatusChip;
